import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import WhatIfSlidersSection from './forecast/WhatIfSlidersSection';
import IncomeSourcesSection from './IncomeSourcesSection';
import useExplorerWhatIf from './useExplorerWhatIf';
import loadingStyles from '../shared/Loading.module.css';
import styles from './ExplorerPage.module.css';

function ScenarioLoadingState({ message, hint }) {
  return (
    <div
      className={loadingStyles['loading-container']}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className={loadingStyles['loading-spinner']} aria-hidden="true">
        <div className={loadingStyles['spinner-ring']} />
        <div className={loadingStyles['spinner-ring']} />
        <div className={loadingStyles['spinner-ring']} />
      </div>
      <p>
        {message}
        {hint ? (
          <>
            <br />
            {hint}
          </>
        ) : null}
      </p>
    </div>
  );
}

function WhatIfLoadingCard() {
  return (
    <div className={styles.loadingCard} aria-busy="true" aria-label="What-if scenario sliders">
      <ScenarioLoadingState message="Loading your scenario…" />
    </div>
  );
}

const ExplorerPage = () => {
  const navigate = useNavigate();

  const handleNeedHelp = useCallback(() => {
    navigate('/dashboard/meet-an-expert');
  }, [navigate]);

  const {
    isLoading,
    userMonthlyIncome,
    partnerMonthlyIncome,
    currentMonthlyExpenses,
    currentRetirementAge,
    isRunningScenario,
    isOpeningForecast,
    onRunScenario,
    scenarioStatus,
    scenarioMessage,
    incomeSources,
    onIncomeSourcesChange,
    hasIncomeSourceChanges,
  } = useExplorerWhatIf();

  if (isRunningScenario || isOpeningForecast) {
    return (
      <div className={`${styles.page} ${styles.handoff}`} data-page="explorer" aria-busy="true">
        <ScenarioLoadingState
          message={isOpeningForecast ? 'Opening your forecast…' : 'Running your scenario…'}
          hint={isOpeningForecast
            ? 'Your scenario is saved. This usually takes a few seconds.'
            : 'This usually takes a few seconds.'}
        />
      </div>
    );
  }

  return (
    <div className={styles.page} data-page="explorer">
      {isLoading ? (
        <WhatIfLoadingCard />
      ) : (
        <>
          <WhatIfSlidersSection
            userMonthlyIncome={userMonthlyIncome}
            partnerMonthlyIncome={partnerMonthlyIncome}
            currentMonthlyExpenses={currentMonthlyExpenses}
            currentRetirementAge={currentRetirementAge}
            isRunningScenario={isRunningScenario}
            onRunScenario={onRunScenario}
            scenarioStatus={scenarioStatus}
            scenarioMessage={scenarioMessage}
            hasIncomeSourceChanges={hasIncomeSourceChanges}
          >
            {({ runScenarioButton }) => (
              <IncomeSourcesSection
                items={incomeSources}
                onItemsChange={onIncomeSourcesChange}
                afterGrid={runScenarioButton}
                onNeedHelp={handleNeedHelp}
              />
            )}
          </WhatIfSlidersSection>
        </>
      )}
    </div>
  );
};

export default ExplorerPage;
